import { PropsWithTestId } from "@js2/components/@types";
import clsx from "clsx";
import React from "react";

type Props = {
  className?: string;
  children: React.ReactNode;
  noLink?: boolean;
};

const RlNavigationSubmenuItem = ({
  className,
  children,
  noLink,
  "data-testid": testId = "main_nav_submenu_item"
}: PropsWithTestId<Props>) => (
  <div
    className={clsx(
      "main-nav__submenu-item",
      className,
      noLink && "main-nav__submenu-item--noLink"
    )}
    data-testid={testId}
  >
    {children}
  </div>
);

export default RlNavigationSubmenuItem;
